import React from 'react';
import './Approach.css';

const steps = [
    {
        icon: '📋',
        title: 'Consultation',
        desc: 'Our experts assess your concerns through an in-depth evaluation, analyzing factors like lifestyle, nutrition, and medical history to recommend tailored solutions for maximum efficacy.',
    },
    {
        icon: '✨',
        title: 'Pre-preparation',
        desc: 'Based on your assessment, we provide guidance on pre-procedure care, ensuring your treatment is smooth, safe, and optimized for the best results.',
    },
    {
        icon: '🩺',
        title: 'Treatment',
        desc: 'With state-of-the-art technology and expert precision, our procedures are performed in a professional, comfortable setting.',
    },
    {
        icon: '🌿',
        title: 'Post-procedure care',
        desc: 'We provide personalized aftercare instructions, product recommendations, and follow-up guidance to maintain and enhance your results.',
    },
];

const Approach = () => {
    return (
        <section className="approach-section">
            <div className="container">
                <div className="approach-header">
                    <span className="section-tag">Our Approach</span>
                    <h2 className="section-title">Personalized Care for Lasting Results</h2>
                    <p className="approach-sub">
                        At Embrace Beauty Aesthetics, we follow a comprehensive, patient-focused approach to
                        ensure safe, effective, and personalized treatments.
                    </p>
                </div>

                <div className="approach-steps-list">
                    {steps.map((s, i) => (
                        <div className="approach-card" key={i}>
                            <div className="card-icon">
                                <span>{s.icon}</span>
                            </div>
                            <div className="card-content">
                                <h3>{s.title}</h3>
                                <p>{s.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <section className="approach-full-screen">
                <img src="/images/embracebanner.jpg" alt="Facial Treatment" className="banner-img" />
            </section>

            <section className="approach-full-image">
                <div className="container">
                    <img src="/images/new2.png" alt="Emcyte Sapphire PRP" className="full-width-img" />
                </div>
            </section>
        </section>
    );
};

export default Approach;
